import { PlayerRole } from "../../../redux/players/playersSlice";
import axios from "../../apiFc24";

export type ArchetypesResponse = PlayerRole[];

export const getArchetypes = async () => {
  const res = await axios.get<ArchetypesResponse>("/squad-builder/archetypes");
  return res.data;
};
